module.exports = __webpack_public_path__ + "img/game1-top.eaa655c4.png";